import * as yup from "yup";

const validation = (
  messages,
  {
    isRia,
    isProfessional,
    needsCA05,
    needsCA06,
    needsCA07,
    requiresSubscriberPaysButDifferentReceiver,
    requiresThirdPartyPayer,
    requiresBothThirdParty,
    requiresTwoSeparateRibs,
    isLumineis = false,
  },
) => {
  // Support both old and new variable names for backward compatibility
  const requiresSubscriberPaysButDifferentReceiverCondition =
    requiresSubscriberPaysButDifferentReceiver ?? false;
  const requiresThirdPartyPayerCondition = requiresThirdPartyPayer ?? false;
  const requiresBothThirdPartyCondition = requiresBothThirdParty ?? false;
  const requiresTwoRibs = requiresTwoSeparateRibs ?? needsCA06;
  return yup.object().shape({
    // CA-01: Social security certificate - Always required
    socialSecurityCertificate: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT),

    // CA-02: RIB - Payment account always required
    paymentAccount: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required(messages.REQUIRED),
        }),
      )
      .required(messages.REQUIRED_ATTACHMENT)
      .min(1, messages.REQUIRED_ATTACHMENT),

    // Refund account - required when two separate RIBs needed
    refundAccount: requiresTwoRibs
      ? yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().required(messages.REQUIRED),
            }),
          )
          .required(messages.REQUIRED_ATTACHMENT)
          .min(1, messages.REQUIRED_ATTACHMENT)
      : yup.array().nullable(),

    // CA-03: Proof of address - not required for LUMINEIS
    proofOfAddress: isLumineis
      ? yup.array().nullable()
      : yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().required(messages.REQUIRED),
            }),
          )
          .required(messages.REQUIRED_ATTACHMENT)
          .min(1, messages.REQUIRED_ATTACHMENT),

    // CIN adherent + CIN receiver (when subscriber pays but doesn't receive)
    // Third-party payer: CIN adherent + CIN payer
    // Both third-party: CIN adherent + CIN payer + CIN receiver
    cin:
      requiresSubscriberPaysButDifferentReceiverCondition ||
      requiresThirdPartyPayerCondition ||
      requiresBothThirdPartyCondition
        ? yup
            .array()
            .of(
              yup.object().shape({
                name: yup.string().required(messages.REQUIRED),
              }),
            )
            .required(messages.REQUIRED_ATTACHMENT)
            .min(1, messages.REQUIRED_ATTACHMENT)
        : yup.array().nullable(),

    payerCin:
      requiresThirdPartyPayerCondition || requiresBothThirdPartyCondition
        ? yup
            .array()
            .of(
              yup.object().shape({
                name: yup.string().required(messages.REQUIRED),
              }),
            )
            .required(messages.REQUIRED_ATTACHMENT)
            .min(1, messages.REQUIRED_ATTACHMENT)
        : yup.array().nullable(),

    receiverCin:
      requiresSubscriberPaysButDifferentReceiverCondition ||
      requiresBothThirdPartyCondition
        ? yup
            .array()
            .of(
              yup.object().shape({
                name: yup.string().required(messages.REQUIRED),
              }),
            )
            .required(messages.REQUIRED_ATTACHMENT)
            .min(1, messages.REQUIRED_ATTACHMENT)
        : yup.array().nullable(),

    socialSecurityCertificateForChildren: yup.boolean().nullable(),
  });
};

export default validation;
